import { ConfigurationsData } from '../config';
import { SetConfigurationAction } from './configuration.types';

export const SET_CONFIGURATION = 'SET_CONFIGURATION';

export const setConfigurations = (): SetConfigurationAction => {
    return {
        type: SET_CONFIGURATION,
        payload: window._env_ as ConfigurationsData
    };
};
